import React from 'react';

/**
 * Palanca global del formulario OC: define qué cantidad multiplica el precio
 * cuando hay tasa personalizada (ej. 10 UNI = 100 KG).
 */
const SubtotalQuantityModeToggle = ({
  value = true,
  onChange,
  disabled = false,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-wrap items-center gap-2 sm:gap-3 px-3 py-2 bg-sky-50 border border-sky-200 rounded-lg ${className}`}
      title="Con tasa personalizada, elige si el subtotal usa la medida convertida o la cantidad ingresada."
    >
      <span className="text-xs sm:text-sm font-medium text-gray-700 whitespace-nowrap">
        Subtotal con:
      </span>
      <div className="inline-flex rounded-md border border-gray-300 overflow-hidden bg-white shadow-sm">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange(true)}
          className={`px-3 py-1.5 text-xs sm:text-sm font-medium transition-colors ${
            value
              ? 'bg-teal-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          } disabled:opacity-50`}
        >
          Medida convertida
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={() => onChange(false)}
          className={`px-3 py-1.5 text-xs sm:text-sm font-medium border-l border-gray-300 transition-colors ${
            !value
              ? 'bg-teal-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          } disabled:opacity-50`}
        >
          Medida ingresada
        </button>
      </div>
    </div>
  );
};

export default SubtotalQuantityModeToggle;
